// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"e6dbdb5f","453":"4f478f33"}[chunkId] + ".chunk.js";
};